import * as UI from "@iyk/ui"
import * as React from "react"

import { FormState, useForm } from "@iyk/vf-forms"
import { Analytics, useAnalytics } from "@iyk/vf-observability/react"
import { GlobalRoutes } from "../../../react-router/routes.ts"

export default function AddToCartButton({
  productVariantId,
  quantity,
  name,
  variant
}: AddToCartButton.Props) {
  const analytics = useAnalytics()

  const { Form, state } = useForm()

  const isSubmitting = FormState.$is("Submitting")(state)

  React.useEffect(() => {
    if (FormState.$is("Succeeded")(state)) {
      UI.toast({
        title: `Added ${quantity} ${quantity === 1 ? "item" : "items"} to your cart`,
        description: `${name} ${variant ? `(${variant})` : ""}`,
        variant: "default"
      })

      analytics.track(Analytics.Event.LineAddedToCart({ productVariantId, quantity }))
    }
  }, [state])

  return (
    <Form method="post" action={GlobalRoutes.shop.cartApi}>
      <input type="hidden" name="productVariantId" value={productVariantId} />
      <input type="hidden" name="quantity" value={quantity} />
      <UI.Button
        type="submit"
        name="_tag"
        value="AddLine"
        kind="solid"
        size="md"
        className="w-full"
        disabled={isSubmitting}
      >
        {isSubmitting ? "Adding to Cart..." : "Add to Cart"}
      </UI.Button>
    </Form>
  )
}

namespace AddToCartButton {
  export interface Props {
    productVariantId: string
    quantity: number
    name: string
    variant?: string
  }
}
